"use client";

import { sanityClient } from "./client";
import imageUrlBuilder from '@sanity/image-url'

const urlBuilder = imageUrlBuilder(sanityClient)

export function sanityImageBuilder(sanityImageObject: object) {
  return urlBuilder.image(sanityImageObject)
}
